import React from 'react';
import { useNavigate } from 'react-router-dom';
import TownFollowPicker from '../components/TownFollowPicker';

/**
 * FollowedTowns — dedicated route for managing the towns a user follows for
 * Safety Alerts. Reuses the existing TownFollowPicker (add/remove towns,
 * auto-provisions a device subscription). Closing returns to the Profile.
 */
const FollowedTowns = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50" data-testid="followed-towns-page">
      <TownFollowPicker open onClose={() => navigate('/profile')} />
    </div>
  );
};

export default FollowedTowns;
